function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { baseKeymap, chainCommands, toggleMark, deleteSelection, selectNodeBackward, splitBlock, createParagraphNear } from 'prosemirror-commands';
import { createAnchor } from '@intercom/composer-ember/lib/commands/anchor';
import { insertHardBreak, customEnterHandlingForCodeBlocks } from '@intercom/composer-ember/lib/commands/insert-hard-break';
import { joinTextBlockToList, liftIfStartOfListItem, liftIfStartOfCallout, joinBackwardAddingBreak, deleteEmptyParagraph } from '@intercom/composer-ember/lib/commands/backspace';
import { splitBlockListItem, splitCollapsibleSectionSummary, splitEmptyTextListItem } from '@intercom/composer-ember/lib/commands/enter';
import { keymap } from 'prosemirror-keymap';
import { splitListItem, liftListItem, sinkListItem } from 'prosemirror-schema-list';
import { undo, redo } from 'prosemirror-history';
import { undoInputRule } from 'prosemirror-inputrules';
import { goToNextCell } from 'prosemirror-tables';
import { selectTextInBlock } from '../commands/select-text-in-block';
import { deleteCollapsibleSection, joinBlocksFromCollapsibleSection, liftBlockFromCollapsibleSection } from '../commands/backspace/collapsible-section-commands';
export default class KeymapPluginBuilder {
  constructor(config, schema) {
    _defineProperty(this, "map", {});
    Object.assign(this.map, baseKeymap);
    this.map.Enter = enterCommands(schema);
    this.map.Backspace = backspaceCommands(config, schema);
    if (schema.marks.bold) {
      this.map['Mod-b'] = toggleMark(schema.marks.bold);
    }
    if (schema.marks.italic) {
      this.map['Mod-i'] = toggleMark(schema.marks.italic);
    }
    if (schema.marks.anchor && !config.disableModKAnchor) {
      this.map['Mod-k'] = createAnchor;
    }
    this.map['Mod-z'] = chainCommands(undoInputRule, undo);
    this.map['Mod-shift-z'] = redo;
    if (!config.singleBlockMode) {
      this.map['Shift-Enter'] = insertHardBreak;
    }
    if (config.allowedBlocks.includes('table')) {
      this.map['Tab'] = chainCommands(sinkListItem(schema.nodes.nestedListItem), goToNextCell(1));
      this.map['Shift-Tab'] = chainCommands(liftListItem(schema.nodes.nestedListItem), goToNextCell(-1));
    }
    if (config.tables?.containers) {
      this.map['Mod-a'] = selectTextInBlock;
      this.map['Mod-Shift-ArrowUp'] = selectTextInBlock;
      this.map['Mod-Shift-ArrowDown'] = selectTextInBlock;
    }
  }
  get plugin() {
    return keymap(this.map);
  }
}
function enterCommands(schema) {
  let commands = [customEnterHandlingForCodeBlocks];
  if (schema.nodes.listItem) {
    commands.push(splitListItem(schema.nodes.listItem), liftListItem(schema.nodes.listItem));
  }
  if (schema.nodes.nestedListItem) {
    commands.push(splitBlockListItem(schema.nodes.nestedListItem), splitEmptyTextListItem(schema.nodes.nestedListItem), splitListItem(schema.nodes.nestedListItem), liftListItem(schema.nodes.nestedListItem));
  }
  if (schema.nodes.collapsibleSection) {
    commands.push(splitCollapsibleSectionSummary);
  }
  commands.push(createParagraphNear, splitBlock);
  return chainCommands(...commands);
}
function backspaceCommands(config, schema) {
  let commands = [undoInputRule, deleteSelection, liftIfStartOfListItem, liftIfStartOfCallout, joinTextBlockToList, joinBackwardAddingBreak, selectNodeBackward];
  if (config.experimental?.deleteEmptyParagraphs) {
    commands = [deleteEmptyParagraph, ...commands];
  }
  if (schema.nodes.collapsibleSection) {
    commands = [deleteCollapsibleSection, liftBlockFromCollapsibleSection, joinBlocksFromCollapsibleSection, ...commands];
  }
  return chainCommands(...commands);
}